import { OTA_Calculation } from "./ota_calculation.model";
import { OTA_TaxAmount } from "./ota_taxamount.model";

export class OTA_Fee {
    public amount: number;
    public amountNet: number;
    public amounTaxt: number;
    public currencyCode: string;
    public taxInclusive: boolean;
    public description: string;
    public includedInRate: boolean;
    public includedInEstTotalInd: boolean;
    public requiredInd: string;
    public purpose: string;
    public taxAmounts = new Array<OTA_TaxAmount>();
    public calculations = new Array<OTA_Calculation>();

    static feeTotal(fee: OTA_Fee): number {
        var total: number = 0;

        if (fee.calculations != null) {
            fee.calculations.forEach(function (calc) {
                total = total + calc.total;
            });
        }
        return total;
    }
}